import axios from "axios";
import api from "../api";

async function getData(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${api.metrics}`, params)
      .then((response) => {
          resolve({
            metrics: response.data.data,
          });
      })
      .catch((error) => {
        reject(error);
      });
  });
}


export default {
  getData
};
